export default "__VITE_ASSET__CbhgoKVZ__"